import {
  MindmapBalanceLayoutIcon,
  MindmapLeftLayoutIcon,
  MindmapRightLayoutIcon,
  SmallArrowDownIcon,
} from '@blocksuite/affine-components/icons';
import { toast } from '@blocksuite/affine-components/toast';
import type { ShapeElementModel } from '@blocksuite/affine-model';
import { downloadBlob } from '@blocksuite/affine-shared/utils';

const UndoIcon = html`<span
  style="color: var(--affine-brand-color); display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px;"
  ><svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    style="display:block;"
  >
    <path
      d="M11.5 18C11.5 18 5.50001 13.5811 5.5 12C5.49999 10.4188 11.5 6 11.5 6"
      stroke="currentColor"
      stroke-width="2.25"
      stroke-linecap="round"
      stroke-linejoin="round"
      vector-effect="non-scaling-stroke"
    ></path>
    <path
      d="M18.5 18C18.5 18 12.5 13.5811 12.5 12C12.5 10.4188 18.5 6 18.5 6"
      stroke="currentColor"
      stroke-width="2.25"
      stroke-linecap="round"
      stroke-linejoin="round"
      vector-effect="non-scaling-stroke"
    ></path></svg
></span>`;

// Back icon (spec)
const BackChevronIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="20"
  height="20"
  color="currentColor"
  fill="none"
>
  <defs></defs>
  <path
    fill="currentColor"
    d="M10.25,6 C10.25,5.586 10.586,5.25 11,5.25 L15.5,5.25 C18.399,5.25 20.75,7.601 20.75,10.5 C20.75,13.399 18.399,15.75 15.5,15.75 L5.463,15.75 C5.627,15.908 5.807,16.07 5.992,16.23 C6.354,16.544 6.718,16.837 6.993,17.051 C7.13,17.158 7.244,17.245 7.323,17.305 C7.363,17.335 7.442,17.394 7.463,17.41 C7.796,17.655 7.85,18.111 7.604,18.445 C7.358,18.778 6.889,18.849 6.555,18.604 C6.532,18.587 6.461,18.534 6.419,18.502 C6.334,18.438 6.214,18.346 6.07,18.234 C5.782,18.009 5.396,17.7 5.008,17.363 C4.624,17.029 4.22,16.654 3.907,16.299 C3.751,16.122 3.601,15.933 3.487,15.743 C3.384,15.574 3.25,15.308 3.25,15 C3.25,14.692 3.384,14.426 3.487,14.257 C3.601,14.067 3.751,13.878 3.907,13.701 C4.22,13.346 4.624,12.971 5.008,12.637 C5.396,12.3 5.782,11.991 6.07,11.766 C6.214,11.654 6.334,11.562 6.419,11.498 C6.461,11.467 6.529,11.415 6.554,11.397 L6.555,11.396 C6.889,11.151 7.358,11.222 7.604,11.555 C7.843,11.88 7.782,12.335 7.469,12.585 C7.448,12.601 7.363,12.665 7.323,12.695 C7.244,12.755 7.13,12.842 6.993,12.949 C6.718,13.163 6.354,13.456 5.992,13.77 C5.807,13.93 5.627,14.092 5.463,14.25 L15.5,14.25 C17.571,14.25 19.25,12.571 19.25,10.5 C19.25,8.429 17.571,6.75 15.5,6.75 L11,6.75 C10.586,6.75 10.25,6.414 10.25,6 Z"
  ></path>
</svg>`;
// Breadcrumb separator
const CrumbSep = html`<span style="opacity:0.6; padding: 0 3px;">›</span>`;

// Remind Me icon - clock with plus
const AddToActionItemsIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="20"
  height="20"
  fill="none"
>
  <path
    fill="currentColor"
    d="M3.25,12 C3.25,17.109 7.391,21.25 12.5,21.25 C12.821,21.25 13.138,21.234 13.45,21.202 C13.862,21.16 14.23,21.46 14.272,21.872 C14.314,22.284 14.014,22.652 13.602,22.694 C13.24,22.731 12.872,22.75 12.5,22.75 C6.563,22.75 1.75,17.937 1.75,12 C1.75,6.063 6.563,1.25 12.5,1.25 C18.437,1.25 23.25,6.063 23.25,12 C23.25,12.735 23.176,13.454 23.035,14.149 C22.953,14.555 22.557,14.817 22.151,14.735 C21.745,14.653 21.483,14.257 21.565,13.851 C21.686,13.253 21.75,12.634 21.75,12 C21.75,6.891 17.609,2.75 12.5,2.75 C7.391,2.75 3.25,6.891 3.25,12 Z M12.5,7.25 C12.914,7.25 13.25,7.586 13.25,8 L13.25,11.689 L14.53,12.97 C14.823,13.263 14.823,13.737 14.53,14.03 C14.237,14.323 13.763,14.323 13.47,14.03 L11.97,12.53 C11.829,12.39 11.75,12.199 11.75,12 L11.75,8 C11.75,7.586 12.086,7.25 12.5,7.25 Z M19,15.25 C19.414,15.25 19.75,15.586 19.75,16 L19.75,18.25 L22,18.25 C22.414,18.25 22.75,18.586 22.75,19 C22.75,19.414 22.414,19.75 22,19.75 L19.75,19.75 L19.75,22 C19.75,22.414 19.414,22.75 19,22.75 C18.586,22.75 18.25,22.414 18.25,22 L18.25,19.75 L16,19.75 C15.586,19.75 15.25,19.414 15.25,19 C15.25,18.586 15.586,18.25 16,18.25 L18.25,18.25 L18.25,16 C18.25,15.586 18.586,15.25 19,15.25 Z"
  />
</svg>`;

const DownloadPngIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="20"
  height="20"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.0046 22.2583C7.59464 22.2583 5.38465 22.2583 3.76465 20.8783C3.53465 20.6783 3.32463 20.4783 3.12463 20.2383C1.74463 18.6183 1.74463 16.4083 1.74463 11.9983C1.74463 7.58829 1.74463 5.3783 3.12463 3.7583C3.32463 3.5283 3.52465 3.31829 3.76465 3.11829C5.38465 1.73829 7.59464 1.73828 12.0046 1.73828H13.5046C13.9146 1.73828 14.2546 2.07828 14.2546 2.48828C14.2546 2.89828 13.9146 3.23828 13.5046 3.23828H12.0046C7.96464 3.23828 5.94463 3.2383 4.74463 4.2583C4.57463 4.3983 4.42467 4.54826 4.28467 4.71826C3.26467 5.91826 3.26465 7.94827 3.26465 11.9783C3.26465 12.9978 3.26465 13.8894 3.28117 14.6719L6.94431 11.0087C7.91431 10.0387 9.59442 10.0387 10.5644 11.0087L14.0044 14.4487L15.4443 13.0087C16.4143 12.0387 18.0944 12.0387 19.0644 13.0087L20.7281 14.6724C20.7446 13.8898 20.7446 12.9981 20.7446 11.9783C20.7446 11.5683 21.0846 11.2283 21.4946 11.2283C21.9046 11.2283 22.2446 11.5683 22.2446 11.9783C22.2446 16.3883 22.2446 18.5983 20.8646 20.2183C20.6646 20.4483 20.4646 20.6583 20.2246 20.8583C18.6046 22.2383 16.3946 22.2383 11.9846 22.2383L12.0046 22.2583ZM3.53439 16.5388C3.49026 16.5829 3.44173 16.6203 3.39014 16.651C3.51697 17.8222 3.77196 18.6351 4.28467 19.2383C4.42467 19.4083 4.57463 19.5582 4.74463 19.6982C5.94463 20.7182 7.97464 20.7183 12.0046 20.7183C16.0346 20.7183 18.0646 20.7182 19.2646 19.6982C19.4346 19.5582 19.5846 19.4083 19.7246 19.2383C20.2373 18.6352 20.4923 17.8223 20.6191 16.6513C20.5673 16.6206 20.5186 16.5831 20.4743 16.5388L18.0044 14.0688C17.6044 13.6688 16.9044 13.6688 16.5044 14.0688L15.0644 15.5087L16.0344 16.4787C16.3244 16.7687 16.3244 17.2488 16.0344 17.5388C15.8844 17.6888 15.6944 17.7588 15.5044 17.7588C15.3144 17.7588 15.1243 17.6888 14.9743 17.5388L9.50437 12.0688C9.10437 11.6688 8.40437 11.6688 8.00437 12.0688L3.53439 16.5388ZM15.5644 7.75562C16.7144 9.21562 17.5944 10.2556 18.5044 10.2556C19.4144 10.2556 20.2943 9.21562 21.4443 7.75562C21.5171 7.66536 21.5856 7.5785 21.65 7.497C21.8066 7.29858 21.9381 7.13196 22.0444 7.02563C22.3344 6.72563 22.3244 6.24558 22.0244 5.96558C21.7244 5.68558 21.2543 5.6856 20.9643 5.9856C20.7943 6.1656 20.5444 6.47557 20.2644 6.83557C20.0344 7.13557 19.6344 7.64567 19.2544 8.06567V2.51562C19.2544 2.10563 18.9144 1.76562 18.5044 1.76562C18.0944 1.76562 17.7544 2.10563 17.7544 2.51562V8.06567C17.4083 7.67413 17.0457 7.21617 16.81 6.91844C16.7868 6.8892 16.7649 6.86151 16.7443 6.83557C16.4643 6.46557 16.2144 6.1556 16.0444 5.9856C15.7544 5.6856 15.2843 5.67558 14.9843 5.96558C14.6843 6.25558 14.6743 6.72563 14.9643 7.02563C15.1143 7.17563 15.3244 7.44562 15.5644 7.75562Z"
    fill="currentColor"
  />
</svg>`;

const REMIND_OPTIONS = [
  { id: 'one_hour', label: 'In 1 hour', value: 'one_hour' },
  { id: 'three_hours', label: 'In 3 hours', value: 'three_hours' },
  { id: 'tomorrow', label: 'Tomorrow', value: 'tomorrow' },
  { id: 'next_week', label: 'Next week', value: 'next_week' },
] as const;

import { renderToolbarSeparator } from '@blocksuite/affine-components/toolbar';
import { WithDisposable } from '@blocksuite/block-std';
import { countBy, maxBy } from '@blocksuite/global/utils';
import { css, html, LitElement, nothing, type TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { join } from 'lit/directives/join.js';
import { repeat } from 'lit/directives/repeat.js';

import type { MindmapElementModel } from '../../../surface-block/element-model/mindmap.js';
import { LayoutType } from '../../../surface-block/element-model/utils/mindmap/layout.js';
import type { EdgelessRootBlockComponent } from '../../edgeless/edgeless-root-block.js';

interface LayoutItem {
  name: string;
  value: LayoutType;
  icon: TemplateResult<1>;
}

const MINDMAP_LAYOUT_LIST: LayoutItem[] = [
  {
    name: 'Left',
    value: LayoutType.LEFT,
    icon: MindmapLeftLayoutIcon,
  },
  {
    name: 'Radial',
    value: LayoutType.BALANCE,
    icon: MindmapBalanceLayoutIcon,
  },
  {
    name: 'Right',
    value: LayoutType.RIGHT,
    icon: MindmapRightLayoutIcon,
  },
] as const;

@customElement('edgeless-change-mindmap-layout-panel')
class EdgelessChangeMindmapLayoutPanel extends LitElement {
  static override styles = css`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      gap: 8px;
    }
  `;

  override render() {
    return repeat(
      MINDMAP_LAYOUT_LIST,
      item => item.value,
      ({ name, value, icon }) => html`
        <editor-icon-button
          aria-label=${name}
          .tooltip=${name}
          .tipPosition=${'top'}
          .active=${this.mindmapLayout === value}
          .activeMode=${'background'}
          @click=${() => this.onSelect(value)}
        >
          ${icon}
        </editor-icon-button>
      `
    );
  }

  @property({ attribute: false })
  accessor mindmapLayout!: LayoutType | null;

  @property({ attribute: false })
  accessor onSelect!: (style: LayoutType) => void;
}

@customElement('edgeless-remind-me-panel')
class EdgelessRemindMePanel extends LitElement {
  static override styles = css`
    :host {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
    }

    .remind-option {
      padding: 4px 8px;
      border: none;
      border-radius: 6px;
      background: none;
      cursor: pointer;
      font-family: 'Outfit', sans-serif;
      font-size: 12px;
      color: var(--affine-text-primary-color);
      transition: background-color 0.1s ease;
      white-space: nowrap;
    }

    .remind-option:hover {
      background-color: var(--affine-hover-color);
    }
  `;

  override render() {
    return html`
      ${REMIND_OPTIONS.map(
        opt => html`
          <button
            class="remind-option"
            @click=${() => this.onSelect(opt.value)}
          >
            ${opt.label}
          </button>
        `
      )}
    `;
  }

  @property({ attribute: false })
  accessor onSelect!: (value: string) => void;
}

@customElement('edgeless-change-mindmap-button')
export class EdgelessChangeMindmapButton extends WithDisposable(LitElement) {
  static override styles = css`
    :host {
      display: inline-flex;
      align-items: center;
      flex: 0 0 auto;
    }
    .undo-accent {
      border-radius: 10px;
      filter: drop-shadow(0 2px 12px rgba(145, 99, 245, 0.55));
      box-shadow: inset 0 0 0 1px rgba(145, 99, 245, 0.35);
      animation: pique-undo-pulse 1.6s ease-in-out 2;
    }

    @keyframes pique-undo-pulse {
      0% {
        transform: scale(1);
        background: rgba(145, 99, 245, 0.08);
      }
      50% {
        transform: scale(1.08);
        background: rgba(145, 99, 245, 0.14);
      }
      100% {
        transform: scale(1);
        background: rgba(145, 99, 245, 0.08);
      }
    }
  `;

  // --- Breadcrumb helpers ---
  private _getBreadcrumbs(): Array<{ id: string; label: string }> {
    try {
      if (!this.nodes || this.nodes.length !== 1) return [];
      const shape = this.nodes[0] as unknown as {
        id: string;
        group?: unknown;
        text?: unknown;
      };
      const mindmap = (shape as unknown as { group: MindmapElementModel })
        .group;
      if (!mindmap || (mindmap as any).type !== 'mindmap') return [];

      const trail: Array<{ id: string; label: string }> = [];
      let currentId: string | null = shape.id;
      while (currentId) {
        const node = (mindmap as any).getNode?.(currentId);
        if (!node) break;
        const text = (node.element as any)?.text?.toString?.() ?? '';
        const label = String(text).trim() || 'Untitled';
        trail.push({ id: currentId, label });
        const parent: { id?: string | null } | null = (mindmap as any).getParentNode?.(currentId);
        currentId = parent?.id ?? null;
      }
      return trail.reverse();
    } catch {
      return [];
    }
  }

  private _zoomToNode(nodeId: string) {
    try {
      const targetMindmap = this.nodes?.[0]
        ? ((this.nodes[0] as unknown as { group: MindmapElementModel })
            .group as any)
        : this._mindmaps.values().next().value;
      if (
        targetMindmap &&
        typeof targetMindmap.handleMindmapNodeClick === 'function'
      ) {
        targetMindmap.handleMindmapNodeClick(nodeId);
      }
    } catch {
      // ignore
    }
  }

  public updateLayoutTypeInternal: ((layoutType: LayoutType) => void) | undefined = (layoutType: LayoutType) => {
    this.elements.forEach(element => {
      element.layoutType = layoutType;
      element.layout();
    });
    this.layoutType = layoutType;
  };

  // Timer hidden; action removed

  // --- Nav Undo support ---
  private _hasAnyNavUndo = () => {
    return this.elements.some(
      element =>
        typeof (element as any).hasPendingNavigationUndo === 'function' &&
        (element as any).hasPendingNavigationUndo()
    );
  };

  private _undoNavigation = () => {
    this.elements.forEach(element => {
      if (typeof (element as any).undoPendingNavigation === 'function') {
        (element as any).undoPendingNavigation();
      }
    });

    // Zoom to the entire mindmap after undoing navigation
    if (this.elements.length > 0) {
      const mindmap = this.elements[0];
      const edgelessService = this.edgeless.service;
      if (mindmap.elementBound && edgelessService?.viewport) {
        setTimeout(() => {
          edgelessService.viewport.setViewportByBound(
            mindmap.elementBound,
            [20, 20, 20, 20],
            true
          );
        }, 100);
      }
    }

    // Force refresh toolbar state so Undo hides and Timer returns if applicable
    this.requestUpdate();
  };
  private _exportMindmap = async () => {
    try {
      const mindmap = this.elements[0];
      if (!mindmap) return;

      const childElements = Array.from(mindmap.childElements);
      if (childElements.length === 0) return;

      const connectors = Array.from(mindmap.connectors.values());
      const allElements = [
        ...childElements,
        ...connectors,
      ] as BlockSuite.SurfaceElementModel[];

      const getMeta =
        typeof (mindmap as any).getNodeMetadata === 'function'
          ? (id: string) =>
              (mindmap as any).getNodeMetadata(id) as {
                category?: string | null;
                timestamp?: string | null;
              }
          : null;

      const baseBound = mindmap.elementBound;
      if (!baseBound) return;

      const tagPadding = 20;
      const expandedBound = {
        x: baseBound.x,
        y: baseBound.y,
        w: baseBound.w,
        h: baseBound.h + tagPadding,
      };

      const surfaceRenderer = this.edgeless.surface.renderer;
      const canvas = surfaceRenderer.getCanvasByBound(expandedBound, allElements);

      if (getMeta) {
        this._drawTagsOnCanvas(canvas, mindmap, expandedBound, getMeta);
      }

      const title = this.edgeless.doc.meta?.title || 'mindmap';
      const defaultFileName = `${title}.png`;

      if (environment.isTauri) {
        const { save } = await import('@tauri-apps/plugin-dialog');
        const { writeFile } = await import('@tauri-apps/plugin-fs');

        const filePath = await save({
          defaultPath: defaultFileName,
          filters: [{ name: 'PNG Image', extensions: ['png'] }],
        });

        if (filePath) {
          const dataUrl = canvas.toDataURL('image/png');
          const base64 = dataUrl.split(',')[1];
          const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
          await writeFile(filePath, bytes);
          toast(this.edgeless.host, 'Mindmap saved');
        }
      } else {
        canvas.toBlob(blob => {
          if (blob) {
            downloadBlob(blob, defaultFileName);
            toast(this.edgeless.host, 'Mindmap exported');
          }
        }, 'image/png');
      }
    } catch (err) {
      console.error('Failed to export mindmap:', err);
    }
  };

  private _drawTagsOnCanvas(
    canvas: HTMLCanvasElement,
    mindmap: MindmapElementModel,
    bound: { x: number; y: number; w: number; h: number },
    getMeta: (id: string) => { category?: string | null; timestamp?: string | null }
  ) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const dpr = window.devicePixelRatio || 1;
    const padding = 6;

    // Reset transform - getCanvasByBound leaves a DPR scale transform active
    ctx.setTransform(1, 0, 0, 1, 0, 0);

    mindmap.traverse(
      node => {
        const meta = getMeta(node.id);
        const category = meta?.category;
        const timestamp = meta?.timestamp;

        const hasCategory = category && category !== 'null';
        const hasTimestamp = timestamp && timestamp !== 'null' && timestamp !== '0:00' && timestamp !== '00:00';

        if (!hasCategory && !hasTimestamp) return;

        const nodeBound = node.element.elementBound;
        const path = mindmap.getPath(node.id);
        const depth = path.length - 1;
        const depthScale = depth <= 0 ? 1 : depth === 1 ? 0.9 : depth === 2 ? 0.8 : 0.7;
        const fontSize = Math.round(11 * depthScale * dpr);

        // Convert model coordinates to canvas pixels
        const nodeX = (nodeBound.x - bound.x) * dpr;
        const nodeY = (nodeBound.y - bound.y) * dpr;
        const nodeW = nodeBound.w * dpr;
        const nodeH = nodeBound.h * dpr;
        const tagY = nodeY + nodeH + padding * dpr;

        ctx.font = `500 ${fontSize}px -apple-system, BlinkMacSystemFont, sans-serif`;

        if (hasCategory) {
          const displayName = this._getCategoryDisplayName(category);
          const colors = this._getCategoryColors(category);
          const categoryX = nodeX + nodeW * 0.25;

          ctx.fillStyle = colors.text;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'top';
          ctx.fillText(`#${displayName}`, categoryX, tagY);
        }

        if (hasTimestamp) {
          const timestampX = nodeX + nodeW * 0.75;

          ctx.fillStyle = '#555';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'top';
          ctx.fillText(timestamp, timestampX, tagY);
        }
      },
      { stopOnCollapse: true }
    );
  }

  private _getCategoryDisplayName(category: string): string {
    const displayNames: Record<string, string> = {
      discussion: 'Discussion',
      decision: 'Decision',
      action_item: 'Action Item',
      quote: 'Quote',
      unresolved: 'Unresolved',
      concern: 'Concern',
      key_insight: 'Key Insight',
      timeline: 'Timeline',
    };
    return displayNames[category] || category;
  }

  private _getCategoryColors(category: string): { text: string } {
    const colors: Record<string, { text: string }> = {
      discussion: { text: '#1B5E20' },
      decision: { text: '#B71C1C' },
      action_item: { text: '#0D47A1' },
      quote: { text: '#E65100' },
      unresolved: { text: '#4A148C' },
      concern: { text: '#E65100' },
      key_insight: { text: '#006064' },
      timeline: { text: '#3E2723' },
    };
    return colors[category] || { text: '#333' };
  }

  private _getCommonLayoutType() {
    const values = countBy(this.elements, element => element.layoutType);
    const max = maxBy(Object.entries(values), ([_k, count]) => count);
    return max ? (Number(max[0]) as LayoutType) : LayoutType.BALANCE;
  }

  private _isSelectedNodeRoot(): boolean {
    if (!this.nodes || this.nodes.length !== 1) return true;
    const shape = this.nodes[0];
    const mindmap = (shape as unknown as { group: MindmapElementModel }).group;
    if (!mindmap || (mindmap as MindmapElementModel).type !== 'mindmap')
      return true;
    return mindmap.tree?.element === shape;
  }

  private _getSelectedNode() {
    if (!this.nodes || this.nodes.length !== 1) return null;
    const shape = this.nodes[0];
    const mindmap = (shape as unknown as { group: MindmapElementModel }).group;
    if (!mindmap || (mindmap as MindmapElementModel).type !== 'mindmap')
      return null;
    return mindmap.getNode(shape.id);
  }

  private _addToActionItems = async (reminderValue: string = 'tomorrow') => {
    const node = this._getSelectedNode();
    if (!node) return;

    const nodeText =
      (
        node.element as unknown as { text?: { toString(): string } }
      ).text?.toString() || '';
    if (!nodeText.trim()) return;

    const breakdownSteps = node.children
      .map(child => {
        const childText =
          (
            child.element as unknown as { text?: { toString(): string } }
          ).text?.toString() || '';
        return {
          id: crypto.randomUUID(),
          title: childText.trim(),
          description: '',
          completed: false,
        };
      })
      .filter(step => step.title);

    const pageService = this.edgeless.std.spec.getService('affine:page') as {
      actionItemsService?: {
        createItem: (input: {
          title: string;
          pageId: string;
          pageTitle: string;
          status: string;
          breakdownSteps?: Array<{
            id: string;
            title: string;
            description: string;
            completed: boolean;
          }>;
          remindLater?: string[];
        }) => { id: string };
      };
    };

    const doc = this.edgeless.doc;
    const pageId = doc.id;
    const pageTitle = doc.meta?.title || 'Untitled';

    const databaseBlocks = doc.getBlocksByFlavour('affine:database') || [];
    let actionItemsDb: ReturnType<typeof doc.getBlockById> = null;
    for (const db of databaseBlocks) {
      const blockId = (db as unknown as { id?: string }).id;
      const model = blockId ? doc.getBlockById(blockId) : null;
      if (
        (model as unknown as { isActionItemsDatabase?: boolean })
          ?.isActionItemsDatabase
      ) {
        actionItemsDb = model;
        break;
      }
    }

    let createdItemId: string | null = null;

    if (actionItemsDb) {
      const dbParent = doc.getParent(actionItemsDb);
      if (!dbParent) return;

      const text = new doc.Text(nodeText.trim());
      const newBlockId = doc.addBlock(
        'affine:paragraph',
        { type: 'text', text },
        dbParent.id
      );
      const newBlock = doc.getBlockById(newBlockId);

      if (newBlock) {
        doc.moveBlocks([newBlock], actionItemsDb);
        createdItemId = newBlockId;

        const dbModel = actionItemsDb as unknown as {
          id: string;
          columns?: Array<{
            id: string;
            type: string;
            name: string;
            data?: { options?: Array<{ id: string; value: string }> };
          }>;
          cells?: Record<
            string,
            Record<string, { columnId: string; value: unknown }>
          >;
          highlightedCardIds?: string[];
          setBreakdownSteps?: (
            rowId: string,
            steps: Array<{
              id: string;
              title: string;
              description: string;
              completed: boolean;
            }>
          ) => void;
        };

        if (dbModel.columns && dbModel.cells) {
          const statusCol = dbModel.columns.find(
            c => c.type === 'select' && c.name === 'Status'
          );
          const todoOption = statusCol?.data?.options?.find(
            o => o.value === 'To Do'
          );
          if (statusCol && todoOption) {
            dbModel.cells[newBlockId] = dbModel.cells[newBlockId] || {};
            dbModel.cells[newBlockId][statusCol.id] = {
              columnId: statusCol.id,
              value: todoOption.id,
            };
          }
          if (
            breakdownSteps.length > 0 &&
            typeof dbModel.setBreakdownSteps === 'function'
          ) {
            dbModel.setBreakdownSteps(newBlockId, breakdownSteps);
          }
        }

        dbModel.highlightedCardIds = [newBlockId];

        let remindLaterCol = dbModel.columns?.find(
          c => c.name === 'Remind Later' || c.name === 'remindLater'
        );

        if (!remindLaterCol && dbModel.columns) {
          const colId = crypto.randomUUID();
          const newCol = {
            id: colId,
            type: 'multi-select',
            name: 'Remind Later',
            data: {
              options: [
                {
                  id: 'three_hours',
                  value: 'three_hours',
                  displayName: '3 Hr',
                  color: 'var(--affine-tag-blue)',
                },
                {
                  id: 'tomorrow',
                  value: 'tomorrow',
                  displayName: 'Tomorrow',
                  color: 'var(--affine-tag-purple)',
                },
              ],
            },
          };
          dbModel.columns.push(newCol);
          remindLaterCol = newCol;
        }

        if (remindLaterCol && dbModel.cells) {
          dbModel.cells[newBlockId] = dbModel.cells[newBlockId] || {};
          dbModel.cells[newBlockId][remindLaterCol.id] = {
            columnId: remindLaterCol.id,
            value: [reminderValue],
          };
        }

        const scrollToCard = (attempts = 0) => {
          const cardElement = document.querySelector(
            `affine-data-view-kanban-card[data-card-id="${newBlockId}"]`
          );
          if (cardElement) {
            const kanbanGroup = cardElement.closest(
              'affine-data-view-kanban-group'
            );
            const kanbanGroups = cardElement.closest(
              '.affine-data-view-kanban-groups'
            );
            if (kanbanGroup && kanbanGroups) {
              const groupRect = kanbanGroup.getBoundingClientRect();
              const containerRect = kanbanGroups.getBoundingClientRect();
              const scrollLeft =
                kanbanGroups.scrollLeft +
                groupRect.left -
                containerRect.left -
                (containerRect.width - groupRect.width) / 2;
              kanbanGroups.scrollTo({
                left: Math.max(0, scrollLeft),
                behavior: 'smooth',
              });
            }
            cardElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          } else if (attempts < 5) {
            setTimeout(() => scrollToCard(attempts + 1), 100);
          } else {
            const blockComponent =
              this.edgeless.std.view.getBlock(dbModel.id) ??
              document.querySelector(`[data-block-id="${dbModel.id}"]`);
            if (blockComponent) {
              blockComponent.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
              });
            }
          }
        };
        setTimeout(scrollToCard, 150);
        setTimeout(() => {
          dbModel.highlightedCardIds = [];
        }, 5000);
      }
    } else if (pageService?.actionItemsService) {
      const result = pageService.actionItemsService.createItem({
        title: nodeText.trim(),
        pageId,
        pageTitle,
        status: 'To Do',
        breakdownSteps: breakdownSteps.length > 0 ? breakdownSteps : undefined,
        remindLater: [reminderValue],
      });
      createdItemId = result?.id ?? null;
    }

    if (createdItemId && reminderValue) {
      window.dispatchEvent(
        new CustomEvent('pique:schedule-reminder', {
          detail: {
            itemId: createdItemId,
            title: nodeText.trim(),
            pageId,
            pageTitle,
            delayOption: reminderValue,
          },
        })
      );
    }
  };

  private get _mindmaps() {
    const mindmaps = new Set<MindmapElementModel>();

    return this.elements.reduce((_, el) => {
      mindmaps.add(el);

      return mindmaps;
    }, mindmaps);
  }

  override render() {
    if (this._hasAnyNavUndo()) {
      const crumbs = this._getBreadcrumbs();
      const fontPx =
        crumbs.length <= 4
          ? 11
          : crumbs.length <= 6
            ? 10
            : crumbs.length <= 8
              ? 9
              : 8;
      return html`
        <div style="display:flex; align-items:center; gap:4px;">
          <div style="display:flex; align-items:center; gap:4px;">
            <editor-icon-button
              aria-label="Back"
              .tooltip=${'Back'}
              .active=${false}
              .activeMode=${'background'}
              .tipPosition=${'top'}
              .iconContainerPadding=${[1, 2]}
              @click=${this._undoNavigation}
            >
              ${BackChevronIcon}
            </editor-icon-button>
          </div>
          <div
            style="display:flex; align-items:center; gap:1px; min-width:0; overflow:hidden; margin-left:6px;"
          >
            ${crumbs.length
              ? crumbs.map(
                  (c, i) => html`
                    ${i > 0 ? CrumbSep : nothing}
                    <div style="flex:0 1 auto; min-width:0; max-width:120px;">
                      <editor-icon-button
                        aria-label=${c.label}
                        .tooltip=${c.label}
                        .active=${i === crumbs.length - 1}
                        .activeMode=${'background'}
                        .iconContainerPadding=${[0, 1]}
                        @click=${() => this._zoomToNode(c.id)}
                      >
                        <span
                          class="label ellipsis"
                          style="display:inline-block; max-width:100%; overflow:hidden; text-overflow:ellipsis; font-size:${fontPx}px; white-space:nowrap;"
                          >${c.label}</span
                        >
                      </editor-icon-button>
                    </div>
                  `
                )
              : nothing}
          </div>
        </div>
      `;
    }

    const isRoot = this._isSelectedNodeRoot();

    return join(
      [
        isRoot
          ? nothing
          : html`
              <editor-menu-button
                .contentPadding=${'4px'}
                .button=${html`
                  <editor-icon-button
                    aria-label="Remind Me"
                    .tooltip=${'Remind Me'}
                  >
                    ${AddToActionItemsIcon} ${SmallArrowDownIcon}
                  </editor-icon-button>
                `}
              >
                <edgeless-remind-me-panel
                  .onSelect=${(value: string) => this._addToActionItems(value)}
                >
                </edgeless-remind-me-panel>
              </editor-menu-button>
            `,

        isRoot
          ? html`
              <editor-icon-button
                aria-label="Export"
                .tooltip=${'Export'}
                @click=${this._exportMindmap}
              >
                ${DownloadPngIcon}
              </editor-icon-button>
            `
          : nothing,

        this._hasAnyNavUndo()
          ? html`
              <editor-icon-button
                aria-label="Back"
                .tooltip=${'Back'}
                class="undo-accent"
                .active=${true}
                .activeMode=${'background'}
                .tipPosition=${'top'}
                @click=${this._undoNavigation}
              >
                ${UndoIcon}
              </editor-icon-button>
            `
          : nothing,
      ].filter(button => button !== nothing),
      renderToolbarSeparator
    );
  }

  get layout() {
    const layoutType = this.layoutType ?? this._getCommonLayoutType();
    return (
      MINDMAP_LAYOUT_LIST.find(item => item.value === layoutType) ||
      MINDMAP_LAYOUT_LIST[1] // default to BALANCE
    );
  }

  @property({ attribute: false })
  accessor edgeless!: EdgelessRootBlockComponent;

  @property({ attribute: false })
  accessor elements!: MindmapElementModel[];

  @state()
  accessor layoutType!: LayoutType;

  @property({ attribute: false })
  accessor nodes!: ShapeElementModel[];
}

export function renderMindmapButton(
  edgeless: EdgelessRootBlockComponent,
  elements?: (ShapeElementModel | MindmapElementModel)[]
) {
  if (!elements?.length) return nothing;

  const mindmaps: MindmapElementModel[] = [];

  elements.forEach(e => {
    if (e.type === 'mindmap') {
      mindmaps.push(e as MindmapElementModel);
    }

    const group = edgeless.service.surface.getGroup(e.id);

    if (group?.type === 'mindmap') {
      mindmaps.push(group as MindmapElementModel);
    }
  });

  if (mindmaps.length === 0) {
    return nothing;
  }

  return html`
    <edgeless-change-mindmap-button
      .elements=${mindmaps}
      .nodes=${elements.filter(e => e.type === 'shape')}
      .edgeless=${edgeless}
    >
    </edgeless-change-mindmap-button>
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'edgeless-change-mindmap-layout-panel': EdgelessChangeMindmapLayoutPanel;
    'edgeless-remind-me-panel': EdgelessRemindMePanel;
    'edgeless-change-mindmap-button': EdgelessChangeMindmapButton;
  }
}
